import { CalendarSyncStorageEnum, IGoogleSyncCalendarData, IOutlookSyncCalendarData } from './types'

type Provider = 'Google' | 'Outlook'

const keyFor = (provider: Provider): CalendarSyncStorageEnum => (provider === 'Google' ? CalendarSyncStorageEnum.googleSyncCalendar : CalendarSyncStorageEnum.outlookSyncCalendar)

export function readSyncDraft(provider: 'Google'): IGoogleSyncCalendarData | null
export function readSyncDraft(provider: 'Outlook'): IOutlookSyncCalendarData | null
export function readSyncDraft(provider: Provider): IGoogleSyncCalendarData | IOutlookSyncCalendarData | null {
  try {
    const raw = localStorage.getItem(keyFor(provider))
    return raw ? JSON.parse(raw) : null
  } catch {
    // Corrupt JSON or storage access blocked - treat as no draft so the page still renders.
    return null
  }
}

export const writeSyncDraft = (provider: Provider, data: IGoogleSyncCalendarData | IOutlookSyncCalendarData): void => {
  localStorage.setItem(keyFor(provider), JSON.stringify(data))
}

export const clearSyncDraft = (provider: Provider): void => {
  localStorage.removeItem(keyFor(provider))
}
